import { Close } from '@mui/icons-material';
import { Alert, Box, Collapse, IconButton, Stack, Typography } from '@mui/material';
import useLocalStorage from '@src/app/hooks/useLocalStorage';
import { FC } from 'react';

export const DashboardAlert: FC = (): JSX.Element => {
  const [alertNews, setAlertNews] = useLocalStorage<boolean>('alertNews', true);

  const close = () => setAlertNews(false);

  return (
    <Box>
      <Collapse in={Boolean(alertNews)}>
        <Alert
          action={
            <IconButton onClick={close}>
              <Close />
            </IconButton>
          }
          sx={{ mb: 2 }}
          severity="info"
        >
          <Stack direction="column" spacing={2}>
            <Typography>
              Multi-Factor Authentication (MFA) is now enabled to enhance account security. We have introduced portal upgrades including
              multi-portfolio view and a refreshed interface.
            </Typography>
          </Stack>
        </Alert>
      </Collapse>
    </Box>
  );
};
